import { optimizeTasksByType } from '@dispatch/shared/services';
import { useNotification } from '@dispatch/web/hooks';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

const OPTIMIZE_HIDE_DURATION = 10000;

export const useOptimize = () => {
  const { notifySuccess, notifyWarning, notifyError } = useNotification();

  const { mutate, error, status } = useMutation(
    ['optimize'],
    (data: { taskTypes: string[] }) => optimizeTasksByType(data),
    {
      onSuccess: (response) => {
        if (response.status === 'running') {
          notifyWarning(
            'Optimizer is already running',
            `Please wait for the current optimization to finish.  Optimizer started at ${new Date(
              response.started
            ).toLocaleString()}`,
            {
              autoHideDuration: OPTIMIZE_HIDE_DURATION,
            }
          );
        }
        if (response.status === 'idle') {
          notifySuccess(
            'Running Optimizer',
            `Optimizer started at ${new Date(
              response.started
            ).toLocaleString()}`,
            {
              autoHideDuration: OPTIMIZE_HIDE_DURATION,
            }
          );
        }
      },
      onError: (error: AxiosError) => {
        const statusCode = error.request.status;

        if (statusCode === 429) {
          notifyWarning(
            'Optimizer is already running',
            `Please wait for the current optimization to finish.`,
            {
              autoHideDuration: OPTIMIZE_HIDE_DURATION,
            }
          );
          return;
        }

        notifyError('Error Optimizing Tasks', `Please try again.`, {
          autoHideDuration: OPTIMIZE_HIDE_DURATION,
        });
      },
    }
  );

  return {
    optimize: mutate,
    error,
    status,
  };
};
